import isBreakElement from '../verifiers/is-break-element';
import textFormatting from '../../text-formatting';
import isMediaContainer from './is-media-container';
import findNextTextContent from './find-next-text-content';

const restoreCollapsedSelection = (selectionData) => {
  if (!selectionData) return;

  let { node, offset } = selectionData;
  if (isBreakElement(node)) {
    offset = [...node.parentNode.childNodes].indexOf(node);
    node = node.parentNode;
  }

  if (isMediaContainer(node)) {
    const contentEditable = node.closest('[contenteditable]');
    node = findNextTextContent(node, contentEditable);
    offset = 0;
  }

  if (!node) return;

  const selection = textFormatting.accessors.getAdvancedSelection();
  selection.nativeSelection.collapse(node, offset);
  selection.refresh();
};

export default restoreCollapsedSelection;
